export default "__VITE_ASSET__kfK3cY0G__"